import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom, Subscription } from "rxjs";
import { LocationCategoryDTO } from "src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO";
import { LocationsService } from "src/app/features/map-features/sections/locations-section/services/Locations.service";
import { VirtualLocationsService } from "src/app/features/map-features/sections/locations-section/services/VirtualLocations.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { environment } from "src/environments/environment";
import { RouteSheet } from "../../models/RouteSheet";
import { RouteSheetLocationDTO } from "../../models/RouteSheetLocationDTO";
import { ProspectLocationDTO } from "../../models/ProspectLocationDTO";
import { RouteSheetService } from "../../service/RouteSheet.service";
import { RouteSheetUtilService } from "../../service/RouteSheetUtil.service";
import { DataNamesDTO } from "src/app/features/map-features/sections/locations-section/models/DataNamesDTO";
import { DynamicCardField } from "../../../../Atoms/route-sheet-card/dynamic-card/dynamic-card.component";

export interface DynamicRouteSheetCard {
  key: string;
  title: string;
  subtitle: string;
  status: string;
  fields: DynamicCardField[];
  source: ProspectLocationDTO;
}

@Component({
  selector: "app-route-sheet-list",
  templateUrl: "./route-sheet-list.component.html",
  styleUrls: ["./route-sheet-list.component.css"],
})
export class RouteSheetListComponent {
  @Input() identifier: string = "";
  @Input() childCategory: number = 0;
  @Input() parentCategory: number = 0;
  @Input() parentCoordX: string = "";
  @Input() parentCoordY: string = "";

  @Output() categoryTotal = new EventEmitter<string>();

  locationCategory: LocationCategoryDTO;
  parentLocationCategory: LocationCategoryDTO;

  locationRouteSheetListResponse: string = "";
  globalFinder: string = "";
  showCacheWarning: boolean = false;

  isRouteOrderFilterValue: boolean = false;
  RouteSheet: RouteSheet;

  originalShownLocationRouteSheetList: RouteSheetLocationDTO[] = [];
  shownLocationRouteSheetList: RouteSheetLocationDTO[] = [];
  mainItemList: RouteSheetLocationDTO[] = [];

  originalShownProspectList: ProspectLocationDTO[] = [];
  shownProspectList: ProspectLocationDTO[] = [];
  mainProspectList: ProspectLocationDTO[] = [];
  dynamicCards: DynamicRouteSheetCard[] = [];
  dataNames: DataNamesDTO[] = [];

  suscription_getRouteSheetList: Subscription;
  subscription_GetRouteListFiltered: Subscription;
  suscription_getDataKeyNames: Subscription;
  suscription_getImages: Subscription;
  suscription_updateRouteSheetLocations: Subscription;

  constructor(
    private dialog: MatDialog,
    public virtualLocationsService: VirtualLocationsService,
    public locationsService: LocationsService,
    public routeSheetService: RouteSheetService,
    private routeSheetUtilService: RouteSheetUtilService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit(): void {
    const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]") as LocationCategoryDTO[];
    this.locationCategory = categories.find((category) => category.id == this.childCategory);
    this.parentLocationCategory = categories.find((category) => category.id == this.parentCategory);
    this.routeSheetService.CreateLayers(this.locationCategory);
    this.getLocationsChildren();
    if(!environment.production) console.log("routesheetlist entre", this.locationCategory);
  }

  ngOnDestroy() {
    if (this.suscription_getRouteSheetList)
      this.suscription_getRouteSheetList.unsubscribe();
    if (this.subscription_GetRouteListFiltered)
      this.subscription_GetRouteListFiltered.unsubscribe();
    if (this.suscription_updateRouteSheetLocations)
      this.suscription_updateRouteSheetLocations.unsubscribe();

    this.routeSheetService.dialogDetailsRef = null;
  }

  isDynamicRouteSheet(): boolean {
    return this.routeSheetUtilService.isDynamicRouteSheet(this.locationCategory);
  }

  get hasItems(): boolean {
    return this.isDynamicRouteSheet() ? (this.shownProspectList != null && this.shownProspectList.length > 0) : (this.shownLocationRouteSheetList != null && this.shownLocationRouteSheetList.length > 0);
  }

  getLocationsChildren() {
    this.locationRouteSheetListResponse = "";
    this.showCacheWarning = false;
    if (this.suscription_getRouteSheetList)
      this.suscription_getRouteSheetList.unsubscribe();

    if (this.isDynamicRouteSheet())
      this.getProspects();
    else
      this.getRouteSheet();
  }

  updateCacheWarning(data: any): void {
    const hasErrors = data?.errors != null && data.errors.length > 0;
    const hasMessages = data?.message != null && data.message.length > 0;
    this.showCacheWarning = hasErrors || hasMessages;
  }

  //#region ------ routesheet clasico ------

  private getRouteSheet() {
    this.suscription_getRouteSheetList = this.locationsService.GetRouteSheet(this.identifier, this.childCategory, "", true, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload).subscribe({
      next: (data) => {
        this.updateCacheWarning(data);
        if (data.isSuccess && data.result != null) {
          this.RouteSheet = data.result;
          this.mainItemList = this.RouteSheet.routeSheetList != null ? data.result.routeSheetList : [];
          this.originalShownLocationRouteSheetList = this.mainItemList;
          this.shownLocationRouteSheetList = this.mainItemList;

          var total = 0;
          if (this.mainItemList.length > 0 && data.result.contador != null)
            total = data.result.contador;
          this.categoryTotal.emit(total.toString());

          if (this.shownLocationRouteSheetList.length == 0)
            this.locationRouteSheetListResponse = "No se encontraron activos asociados";
          else
            this.updateLayersMap();

          this.routeSheetService.isForceReload = false;
        } else {
          Sentry.captureMessage('RouteSheetList.getRouteSheet: isSuccess false', { level: 'warning', extra: { response: data } });
          this.clearClassicList("No se encontraron activos asociados");
        }
      },
      error: (error) => {
        console.error('Error de activos asociados, de routesheet', error);
        this.clearClassicList("Error al cargar activos asociados");
      }
    });
  }

  private clearClassicList(message: string) {
    this.locationRouteSheetListResponse = message;
    this.showCacheWarning = false;
    this.shownLocationRouteSheetList = [];
    this.originalShownLocationRouteSheetList = [];
    this.mainItemList = [];
    this.categoryTotal.emit("0");
  }

  //#endregion

  //#region ------ routesheet dinamico ------

  private getProspects() {
    this.suscription_getRouteSheetList = this.virtualLocationsService.getProspectsList(this.identifier, this.childCategory, "", true, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload).subscribe({
      next: (data) => {
        this.updateCacheWarning(data);
        if (data.isSuccess && data.result != null) {
          this.RouteSheet = {
            routeSheetList: [],
            geoJSONRoute: data.result.geoJSONRoute,
            geoJSONCheckpoints: data.result.geoJSONCheckpoints,
            contador: data.result.contador
          };

          this.mainProspectList = data.result.list != null ? data.result.list : [];
          this.originalShownProspectList = this.mainProspectList;
          this.shownProspectList = this.mainProspectList;
          this.buildDynamicCards();
          this.loadDataNames(this.shownProspectList);

          var total = 0;
          if (this.mainProspectList.length > 0 && data.result.contador != null)
            total = data.result.contador;
          this.categoryTotal.emit(total.toString());

          if (this.shownProspectList.length == 0)
            this.locationRouteSheetListResponse = "No se encontraron activos asociados";
          else
            this.updateLayersMap();

          this.routeSheetService.isForceReload = false;
        } else {
          Sentry.captureMessage('RouteSheetList.getProspects: isSuccess false', { level: 'warning', extra: { response: data } });
          this.clearDynamicList("No se encontraron activos asociados");
        }
      },
      error: (error) => {
        console.error('Error de prospectos cercanos, de routesheet', error);
        this.clearDynamicList("Error al cargar activos asociados");
      }
    });
  }

  private clearDynamicList(message: string) {
    this.locationRouteSheetListResponse = message;
    this.showCacheWarning = false;
    this.shownProspectList = [];
    this.buildDynamicCards();
    this.originalShownProspectList = [];
    this.mainProspectList = [];
    this.categoryTotal.emit("0");
  }

  private buildDynamicCards() {
    this.dynamicCards = (this.shownProspectList ?? []).map((prospect) => ({
      key: prospect.identifierChild,
      title: prospect.title,
      subtitle: prospect.description,
      status: prospect.locationCategoryStatus,
      fields: (prospect?.virtualLocationDTO?.data ?? [])
        .filter((item) => item.key != null && item.key !== "" && this.isKeyVisible(item.key))
        .map((item) => ({ label: this.getUsableName(item.key), value: item.value })),
      source: prospect
    }));
  }

  private getUsableName(keyName: string): string {
    const keyNameObject = this.dataNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  private isKeyVisible(keyName: string): boolean {
    const keyNameObject = this.dataNames.find((item) => item.keyName === keyName);
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  private async loadDataNames(list: ProspectLocationDTO[]) {
    const keysSet = new Set<string>();
    list.forEach(item => item.virtualLocationDTO?.data?.forEach((d) => keysSet.add(d.key)));

    if (this.locationCategory?.name)
      keysSet.add(this.locationCategory.name);

    const keys = Array.from(keysSet);
    if (keys.length === 0) {
      this.dataNames = [];
      return;
    }

    try {
      const result = await firstValueFrom(this.locationsService.getDataNames(keys));
      if (result.isSuccess) {
        this.dataNames = result.result;
        this.buildDynamicCards();
      }
    } catch (error) {
      console.error("Error al obtener dataNames del routesheet", error);
    }
  }

  //#endregion

  async updateLayersMap() {
    await this.routeSheetService.setRouteSheetLayers(this.RouteSheet.geoJSONRoute, this.RouteSheet.geoJSONCheckpoints, this.parentLocationCategory, this.locationCategory);
  }

  clickLocation(routeSheetLocation: any): void {
    this.routeSheetService.openRouteSheetDetailsPopup(routeSheetLocation, this.parentCoordX, this.parentCoordY);
  }

  filter(filterValue: string) {
    this.globalFinder = filterValue;

    if (this.subscription_GetRouteListFiltered)
      this.subscription_GetRouteListFiltered.unsubscribe();

    if (this.globalFinder.length == 0) {
      this.shownLocationRouteSheetList = this.mainItemList;
      this.shownProspectList = this.mainProspectList;
      this.buildDynamicCards();
      this.routeSheetService.isLoadingList = false;
      return;
    }

    this.routeSheetService.isLoadingList = true;
    this.locationRouteSheetListResponse = "";

    if (this.isDynamicRouteSheet()) {
      this.shownProspectList = [];
      this.buildDynamicCards();
      this.subscription_GetRouteListFiltered = this.virtualLocationsService.getProspectsList(this.identifier, this.childCategory, this.globalFinder, false, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload)
        .subscribe({
          next: (data: any) => {
            this.updateCacheWarning(data);
            if (data.isSuccess && data.result != null) {
              this.shownProspectList = data.result.list != null ? data.result.list : [];
              this.buildDynamicCards();
              if (this.shownProspectList.length == 0)
                this.locationRouteSheetListResponse = "No hay resultados de busqueda";
            } else {
              Sentry.captureMessage('RouteSheetList.filterProspects: isSuccess false', { level: 'warning', extra: { response: data } });
            }
            this.routeSheetService.isLoadingList = false;
          },
          error: (error) => {
            console.error('Error de filtro de prospectos, de routesheet', error);
            this.locationRouteSheetListResponse = "Error al buscar activos";
            this.routeSheetService.isLoadingList = false;
          }
        });
      return;
    }

    this.shownLocationRouteSheetList = [];
    this.subscription_GetRouteListFiltered = this.locationsService.GetRouteSheet(this.identifier, this.childCategory, this.globalFinder, false, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload)
      .subscribe({
        next: (data: any) => {
          this.updateCacheWarning(data);
          if (data.isSuccess) {
            this.shownLocationRouteSheetList = data.result.routeSheetList;
            if (this.shownLocationRouteSheetList.length == 0)
              this.locationRouteSheetListResponse = "No hay resultados de busqueda";
          } else {
            Sentry.captureMessage('RouteSheetList.filterRouteSheet: isSuccess false', { level: 'warning', extra: { response: data } });
          }
          this.routeSheetService.isLoadingList = false;
        },
        error: (error) => {
          console.error('Error de filtro de activos asociados, de routesheet', error);
          this.locationRouteSheetListResponse = "Error al buscar activos";
          this.routeSheetService.isLoadingList = false;
        }
      });
  }

  drop(event: CdkDragDrop<RouteSheetLocationDTO[]>) {
    moveItemInArray(this.shownLocationRouteSheetList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.shownLocationRouteSheetList.length; i++) {
      this.shownLocationRouteSheetList[i].noOrder = i + 1;
    }
  }

  refreshRelatedList() {
    this.shownLocationRouteSheetList = this.originalShownLocationRouteSheetList;
    this.shownProspectList = this.originalShownProspectList;
    this.buildDynamicCards();
  }

  updateRelatedList() {
    //to do: esperar definicion
  }

  setOrder(order: boolean) {
    if (this.isRouteOrderFilterValue == order)
      return;
    this.isRouteOrderFilterValue = order;
    this.shownLocationRouteSheetList = [];
    this.shownProspectList = [];
    this.buildDynamicCards();
    this.getLocationsChildren();
  }

  forceReload() {
    this.routeSheetService.isForceReload = true;
    this.shownLocationRouteSheetList = [];
    this.shownProspectList = [];
    this.buildDynamicCards();
    this.getLocationsChildren();
  }
}
